// extracted by mini-css-extract-plugin
module.exports = {"date":"CEAZR","eventList":"NbWHW","dateText":"_2EfPl","eventDetails":"_34xgK","dateWithChevron":"zEZUP","dateChevron":"_3jxSU","close":"pZgK6"};